export const smallCaps = {
  letterSpacing: 2,
  textTransform: 'uppercase'
};
